export default {
  // 頁面標題和操作
  backToDashboard: '返回寵物儀表板',
  shareCareInstructions: '分享照護指示',
  edit: '編輯',
  preview: '預覽',
  
  // 空狀態
  petNotFound: '找不到寵物',
  petNotFoundDesc: '此寵物可能已被刪除或不存在',
  
  // 基本資訊
  basicInfo: '基本資訊',
  unnamedPet: '未命名寵物',
  notSpecified: '未指定',
  unknown: '未知',
  notSet: '未設定',
  
  // 類型和性別
  type: '類型',
  breed: '品種',
  age: '年齡',
  birthDate: '出生日期',
  gender: '性別',
  male: '公',
  female: '母',
  weight: '體重',
  height: '身高',
  color: '毛色',
  coatType: '毛髮類型',
  eyeColor: '眼睛顏色',
  bodySize: '體型大小',
  specialMarkings: '特殊標記',
  microchipId: '晶片編號',
  registrationId: '登記編號',
  currentLocation: '目前位置',
  
  // 時間單位
  year: '年',
  years: '年',
  month: '月',
  months: '月',
  
  // 區塊標題
  physicalTraits: '外觀特徵',
  dietaryInfo: '飲食資訊',
  behaviorInfo: '行為資訊',
  healthInfo: '健康資訊',
  veterinarianInfo: '獸醫資訊',
  specialNotes: '特殊備註',
  
  // 飲食相關
  feedingSchedule: '餵食時間表',
  nextFeeding: '下次餵食',
  canEat: '可以吃',
  cannotEat: '不能吃',
  breakfast: '早餐',
  lunch: '午餐',
  dinner: '晚餐',
  snack: '點心',
  portionSize: '份量',
  foodType: '食物類型',
  time: '時間',
  
  // 行為相關
  temperament: '性格',
  likes: '喜歡',
  dislikes: '不喜歡',
  exerciseNeeds: '運動需求',
  trainingNotes: '訓練筆記',
  
  // 健康相關
  medicationSchedule: '用藥時間表',
  nextMedication: '下次用藥',
  medications: '藥物',
  medicationName: '藥物名稱',
  dosage: '劑量',
  frequency: '頻率',
  daily: '每日',
  twiceDaily: '每日兩次',
  thriceDaily: '每日三次',
  weekly: '每週',
  monthly: '每月',
  custom: '自訂',
  morningMeds: '早上用藥',
  afternoonMeds: '下午用藥',
  eveningMeds: '晚上用藥',
  nightMeds: '夜間用藥',
  vaccines: '疫苗接種',
  nextVaccineDate: '下次疫苗接種日期',
  nextVetVisit: '下次獸醫就診',
  allergies: '過敏',
  medicalConditions: '醫療狀況',
  
  // 獸醫資訊
  vetName: '獸醫診所',
  vetPhone: '獸醫電話',
  vetAddress: '獸醫地址',
  vetEmail: '獸醫電子郵件',
  insuranceProvider: '保險公司',
  insurancePolicy: '保單號碼',
  
  // 載入狀態
  loadingPet: '正在載入寵物資料...',
  
  // 未填寫狀態
  notFilled: '未填寫',
  home: '在家',
};